import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GoogleMapState {
    loaded: boolean;
    franchiseId?: ModelId;
    selectedZone: ModelId | null;
    zonePolygons: ModelId[],
    newPolygon: number;
}

const initialState: GoogleMapState = {
    loaded: false,
    zonePolygons: [],
    selectedZone: null,
    newPolygon: 0
};

export const googleMapSlice = createSlice({
    name: 'googleMap',
    initialState,
    reducers: {
        init(state) {
            state.zonePolygons = [];
        },
        setFranchise(state, action: PayloadAction<ModelId | undefined>) {
            state.franchiseId = action.payload;
        },
        setLoaded(state, action: PayloadAction<boolean>) {
            state.loaded = action.payload;
        },
        setZonePolygon(state, action: PayloadAction<{ id: ModelId, index: number; }>) {
            state.zonePolygons[action.payload.index] = action.payload.id;
        },
        selectZone(state, action: PayloadAction<ModelId | null>) {
            state.selectedZone = action.payload;
        },
        onPolygonCreated(state) {
            // just alterate the store... for a scope problem
            state.newPolygon = state.newPolygon + 1;
        }
    }
});
